import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.includes.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("d2-container", [_c("div", {
    staticClass: "wlc-form"
  }, [_c("el-form", {
    staticClass: "wlc-form-section user-card",
    attrs: {
      "label-width": "70px"
    }
  }, [_c("div", {
    staticClass: "section-header"
  }, [_vm._v(" Lifestyle基本信息"), _c("span", [_vm._v(" | 注册时间：" + _vm._s(_vm.userForm.createTime))])]), _c("el-form-item", {
    attrs: {
      label: "用户头像"
    }
  }, [_c("wlc-upload-image", {
    attrs: {
      width: "140px",
      height: "140px",
      url: _vm.userForm.avatar,
      preview: true,
      random: true,
      multimediaType: "userProfilePic"
    },
    on: {
      "update:url": function updateUrl($event) {
        return _vm.$set(_vm.userForm, "avatar", $event);
      }
    }
  }), _c("div", {
    staticClass: "user-info"
  }, [_vm.userForm.user_type == 1 || _vm.userForm.user_type == 3 ? _c("div", {}, [_c("span", [_vm._v("用户类型：")]), _vm.userForm.user_type == 1 ? _c("span", {
    staticStyle: {
      color: "#c70909"
    }
  }, [_vm._v("品牌充值")]) : _vm._e(), _vm.userForm.user_type == 3 ? _c("span", {
    staticStyle: {
      color: "#c70909"
    }
  }, [_vm._v("品牌季度")]) : _vm._e()]) : _vm._e(), _c("div", {
    staticClass: "from"
  }, [_vm._v(" 来自： "), _vm.userForm.scene == 1 ? _c("span", [_vm._v("用户裂变")]) : _vm.userForm.scene == 2 ? _c("span", [_vm._v("城市大使 ")]) : _c("span", [_vm._v("自然用户")])]), _vm.userForm.newestAppInfo ? _c("div", {
    staticClass: "ip-facility"
  }, [_vm.userForm.newestAppInfo.phoneBrand ? _c("span", [_vm._v(_vm._s(_vm.userForm.newestAppInfo && _vm.userForm.newestAppInfo.phoneBrand) + " - ")]) : _vm._e(), _c("span", [_vm._v(_vm._s(_vm.userForm.newestAppInfo && _vm.userForm.newestAppInfo.phoneModel))])]) : _vm._e(), _c("div", {
    staticClass: "device-risk"
  }, [_vm.deviceRisk.risk_code ? _c("div", {
    staticClass: "row"
  }, [_vm.deviceRisk.risk_code.length ? _c("div", {
    staticClass: "col",
    class: {
      "col-gray": _vm.deviceRisk.risk_level == -1
    }
  }, [_c("span", [_vm._v("数盟 - " + _vm._s(_vm.deviceRisk.risk_code.join("/")))])]) : _vm._e(), _vm.deviceRisk.risk_code.length && (_vm.deviceRisk.status == 1 || _vm.deviceRisk.status == 2) ? _c("span", {
    staticClass: "line"
  }, [_vm._v("|")]) : _vm._e(), _vm.deviceRisk.status == 1 ? _c("div", {
    staticClass: "col"
  }, [_vm._v(" 高危标记设备 ")]) : _vm._e(), _vm.deviceRisk.status == 2 ? _c("div", {
    staticClass: "col"
  }, [_vm._v(" 高危感知源 "), _vm.deviceRisk.status_remark ? _c("span", [_vm._v(" : " + _vm._s(_vm.deviceRisk.status_remark) + " ")]) : _vm._e()]) : _vm._e(), _vm.deviceRisk.perception_code ? _c("span", {
    staticClass: "line"
  }, [_vm._v("|")]) : _vm._e(), _vm.deviceRisk.perception_code ? _c("div", {
    staticClass: "col"
  }, [_vm._v(" 高危Wi-Fi感知 "), _vm.getPerceptionCodeName ? _c("span", [_vm._v(": " + _vm._s(_vm.getPerceptionCodeName))]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm.deviceRisk.relevance_account > 1 ? _c("div", {
    staticClass: "row"
  }, [_c("div", {
    staticClass: "col"
  }, [_c("span", [_vm._v(" 数盟 - 关联账号 * " + _vm._s(_vm.deviceRisk.relevance_account) + "： ")]), _c("wlc-user-list-pop", {
    attrs: {
      list: _vm.deviceRisk.user_list
    }
  })], 1), _vm.deviceRisk.relevance_account > 1 && _vm.deviceRisk.status == 0 && !_vm.deviceRisk.perception_code ? _c("div", {
    staticClass: "col"
  }, [_c("el-button", {
    attrs: {
      size: "mini",
      type: "danger",
      plain: ""
    },
    on: {
      click: _vm.goDeviceList
    }
  }, [_vm._v("设高危")])], 1) : _vm._e()]) : _vm._e()]), _c("div", {
    staticClass: "mtb4"
  }, [_vm.userForm.virtualNumber ? _c("el-tag", {
    staticClass: "mr8 wlc-important-tag",
    attrs: {
      size: "small",
      type: "danger"
    }
  }, [_vm._v("虚拟号 ")]) : _vm._e(), _vm.userForm.phoneCounty && _vm.userForm.phoneCounty != "中国" ? _c("el-tag", {
    staticClass: "mr8 wlc-important-tag",
    attrs: {
      size: "small",
      type: "danger"
    }
  }, [_vm._v(_vm._s(_vm.userForm.phoneCounty) + " ")]) : _vm._e(), _c("el-input", {
    staticClass: "w200",
    attrs: {
      size: "mini",
      disabled: ""
    },
    model: {
      value: _vm.userForm.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.userForm, "phone", $$v);
      },
      expression: "userForm.phone"
    }
  }, [_c("el-button", {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: _vm.userForm.phone,
      expression: "userForm.phone",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: _vm.onCopy,
      expression: "onCopy",
      arg: "success"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:error",
      value: _vm.onError,
      expression: "onError",
      arg: "error"
    }],
    attrs: {
      slot: "append",
      icon: "el-icon-document-copy"
    },
    slot: "append"
  }, [_vm._v("复制 ")])], 1)], 1)]), _vm.userTag.length > 0 ? _c("div", {
    staticClass: "user-tag"
  }, [_c("wlc-user-table-tag", {
    attrs: {
      height: "120px",
      width: "320px",
      userId: _vm.$route.query.userId,
      list: _vm.userTag
    }
  })], 1) : _vm._e()], 1), _c("el-row", {
    staticClass: "mtb20",
    attrs: {
      gutter: 60
    }
  }, [_c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "昵称"
    }
  }, [_c("el-input", {
    staticClass: "w200",
    model: {
      value: _vm.userForm.name,
      callback: function callback($$v) {
        _vm.$set(_vm.userForm, "name", $$v);
      },
      expression: "userForm.name"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "备注"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.userForm.remark,
      callback: function callback($$v) {
        _vm.$set(_vm.userForm, "remark", $$v);
      },
      expression: "userForm.remark"
    }
  })], 1)], 1)], 1)], 1), _c("el-form", {
    staticClass: "wlc-form-section upload-container"
  }, [_c("div", {
    staticClass: "section-header"
  }, [_vm._v("图片&视频")]), _c("div", {
    staticClass: "wlc-video-action"
  }, [_vm.form.video && !_vm.form.imgs.includes(_vm.form.cover) ? _c("div", {
    staticClass: "wlc-video-cover"
  }, [_c("span", [_vm._v("封面")]), _c("wlc-image", {
    attrs: {
      src: _vm.form.cover,
      width: "200",
      height: "150",
      compression: false,
      multimediaType: "lifestylePic"
    }
  })], 1) : _c("wlc-upload-video", {
    attrs: {
      width: "200px",
      height: "150px",
      url: _vm.form.video,
      multimediaType: "lifestyleVideo"
    },
    on: {
      "update:url": function updateUrl($event) {
        return _vm.$set(_vm.form, "video", $event);
      }
    }
  }), _vm.form.video ? _c("div", {
    staticClass: "icon-group"
  }, [_c("i", {
    staticClass: "fa fa-file-photo-o",
    on: {
      click: function click($event) {
        $event.stopPropagation();
        _vm.videoVisible = true;
      }
    }
  }), _c("i", {
    staticClass: "fa fa-close",
    on: {
      click: function click($event) {
        $event.stopPropagation();
        return _vm.deleteVideo();
      }
    }
  })]) : _vm._e()], 1), _vm._l(_vm.form.imgs, function (item, index) {
    return _c("div", {
      directives: [{
        name: "dragging",
        rawName: "v-dragging",
        value: {
          item: item,
          list: _vm.form.imgs,
          group: "item"
        },
        expression: "{\n                        item: item,\n                        list: form.imgs,\n                        group: 'item',\n                    }"
      }],
      key: index,
      staticClass: "wlc-image-item"
    }, [_c("img", {
      staticClass: "img",
      attrs: {
        src: _vm.thumbnailUrl(item)
      },
      on: {
        click: function click($event) {
          return _vm.setCover(item);
        }
      }
    }), item == _vm.form.cover ? _c("img", {
      staticClass: "icon-cover",
      attrs: {
        src: "".concat(_vm.$baseUrl, "image/icon-cover.png"),
        width: "50px"
      }
    }) : _vm._e(), _c("div", {
      staticClass: "icon-group"
    }, [_c("i", {
      staticClass: "fa fa-eye",
      on: {
        click: function click($event) {
          $event.stopPropagation();
          return _vm.previewImage(index);
        }
      }
    }), _c("i", {
      staticClass: "fa fa-repeat",
      on: {
        click: function click($event) {
          $event.stopPropagation();
          return _vm.selectRotateImg(index);
        }
      }
    }), _c("i", {
      staticClass: "fa fa-close",
      on: {
        click: function click($event) {
          $event.stopPropagation();
          return _vm.deleteImage(index, item);
        }
      }
    })])]);
  }), _c("wlc-upload-image", {
    attrs: {
      url: _vm.form.url,
      visible: false,
      width: "200px",
      height: "150px",
      multimediaType: "lifestylePic"
    },
    on: {
      "update:url": function updateUrl($event) {
        return _vm.$set(_vm.form, "url", $event);
      }
    }
  })], 2), _c("el-form", {
    staticClass: "wlc-form-section lifestyle-info",
    attrs: {
      "label-width": "40px"
    }
  }, [_c("el-row", {
    attrs: {
      gutter: 60
    }
  }, [_c("el-col", {
    attrs: {
      span: 16
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "标题"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.form.title,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "title", $$v);
      },
      expression: "form.title"
    }
  }), _vm.form.title_is_custom == 0 ? _c("el-tag", {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      type: "success"
    }
  }, [_vm._v("系统抓取")]) : _vm._e(), _vm.form.location_city ? _c("el-tag", {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      type: "info"
    }
  }, [_vm._v("发布地：" + _vm._s(_vm.form.location_city))]) : _vm._e(), _vm.form.match_location ? _c("el-tag", {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      type: _vm.form.fraud == 2 ? "danger" : "info"
    }
  }, [_vm._v("IP属地：" + _vm._s(_vm.form.match_location))]) : _vm._e(), _c("el-tag", {
    attrs: {
      type: "info"
    }
  }, [_vm._v("发布时间：" + _vm._s(_vm.form.create_at))])], 1)], 1), _c("el-col", {
    attrs: {
      span: 8
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "地址"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.form.location,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "location", $$v);
      },
      expression: "form.location"
    }
  })], 1)], 1)], 1), _c("el-form-item", {
    staticClass: "lifestyle-desc",
    attrs: {
      label: "描述"
    }
  }, [_c("el-input", {
    attrs: {
      type: "textarea",
      rows: "10",
      autosize: ""
    },
    model: {
      value: _vm.form.content,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "content", $$v);
      },
      expression: "form.content"
    }
  }), _c("div", {
    staticClass: "lifestyle-tag"
  }, [_c("el-popover", {
    attrs: {
      placement: "top",
      width: "80",
      trigger: "click"
    }
  }, [_c("div", {
    staticClass: "lifestyle-tag-list"
  }, _vm._l(_vm.tagList, function (tag) {
    return _c("div", {
      key: tag.id,
      staticClass: "tag-item",
      on: {
        click: function click($event) {
          return _vm.selectTag(tag.name);
        }
      }
    }, [_vm._v(_vm._s(tag.name))]);
  }), 0), _c("el-button", {
    attrs: {
      slot: "reference",
      size: "mini",
      icon: "el-icon-plus"
    },
    slot: "reference"
  }, [_vm._v("添加标签")])], 1)], 1)], 1)], 1), _c("el-form", [_c("el-row", {
    attrs: {
      gutter: 60
    }
  }, [_c("el-col", {
    attrs: {
      span: 8
    }
  }, [_c("el-form-item", {
    staticClass: "wlc-lifestyle-data",
    attrs: {
      label: "浏览量"
    }
  }, [_c("el-input", {
    staticClass: "d2-mr-10",
    attrs: {
      disabled: ""
    },
    model: {
      value: _vm.form.views_num,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "views_num", $$v);
      },
      expression: "form.views_num"
    }
  }), _c("el-select", {
    attrs: {
      "allow-create": "",
      filterable: ""
    },
    model: {
      value: _vm.form.append_views_num,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "append_views_num", $$v);
      },
      expression: "form.append_views_num"
    }
  }, _vm._l(_vm.addDataList, function (item) {
    return _c("el-option", {
      key: item.views_num,
      attrs: {
        label: item.views_num,
        value: item.views_num
      }
    });
  }), 1)], 1)], 1), _c("el-col", {
    attrs: {
      span: 8
    }
  }, [_c("el-form-item", {
    staticClass: "wlc-lifestyle-data",
    attrs: {
      label: "收藏量"
    }
  }, [_c("el-input", {
    staticClass: "d2-mr-10",
    attrs: {
      disabled: ""
    },
    model: {
      value: _vm.form.collect_num,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "collect_num", $$v);
      },
      expression: "form.collect_num"
    }
  }), _c("el-select", {
    attrs: {
      "allow-create": "",
      filterable: ""
    },
    model: {
      value: _vm.form.append_collect_num,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "append_collect_num", $$v);
      },
      expression: "form.append_collect_num"
    }
  }, _vm._l(_vm.addDataList, function (item) {
    return _c("el-option", {
      key: item.collect_num,
      attrs: {
        label: item.collect_num,
        value: item.collect_num
      }
    });
  }), 1)], 1)], 1)], 1), _c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.save
    }
  }, [_vm._v("保存")]), _vm.form.audit_status == 0 ? _c("el-button", {
    attrs: {
      type: "success"
    },
    on: {
      click: function click($event) {
        return _vm.audit(1);
      }
    }
  }, [_vm._v("通过")]) : _vm._e(), _vm.form.audit_status == 0 ? _c("el-button", {
    attrs: {
      type: "info"
    },
    on: {
      click: function click($event) {
        return _vm.audit(2);
      }
    }
  }, [_vm._v("拒绝")]) : _vm._e(), _c("el-button", {
    attrs: {
      type: "warning"
    },
    on: {
      click: _vm.recommend
    }
  }, [_vm._v(_vm._s(_vm.form.is_recommend ? "取消推荐" : "推荐"))]), _vm.btnNextVisible ? _c("wlc-btn-next") : _vm._e()], 1)], 1)], 1), _c("el-dialog", {
    attrs: {
      title: "选择封面",
      visible: _vm.videoVisible,
      width: "90%"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.videoVisible = $event;
      }
    }
  }, [_c("video", {
    staticStyle: {
      width: "100%",
      height: "600px"
    },
    attrs: {
      src: _vm.form.video,
      controls: "controls",
      id: "J_video"
    }
  }, [_vm._v(" 您的浏览器不支持 video 标签。 ")]), _c("div", {
    staticStyle: {
      "text-align": "center",
      margin: "20px 0"
    }
  }, [_c("el-button", {
    on: {
      click: function click($event) {
        _vm.videoVisible = false;
      }
    }
  }, [_vm._v("取 消")]), _c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.selectVideoPreview
    }
  }, [_vm._v("确 定")])], 1)]), _c("el-dialog", {
    staticClass: "wlc-image-preview",
    attrs: {
      top: "5vh",
      fullscreen: true,
      visible: _vm.previewDialogVisible
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.previewDialogVisible = $event;
      }
    }
  }, [_c("el-carousel", {
    ref: "carousel",
    attrs: {
      "indicator-position": "none",
      autoplay: false,
      arrow: "always"
    }
  }, _vm._l(_vm.form.imgs, function (item) {
    return _c("el-carousel-item", {
      key: item
    }, [_c("img", {
      staticStyle: {
        width: "100%",
        height: "100%",
        "object-fit": "contain"
      },
      attrs: {
        src: item
      }
    })]);
  }), 1)], 1)], 1), _vm.imageRotateDialogVisible ? _c("wlc-image-rotate", {
    attrs: {
      url: _vm.imageRotateUrl
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };